import { ClassAttributes, createElement, Fragment } from 'react';

import DraftModificationRequestIconWithTooltip from '../../component/primitive/DraftModificationRequestIconWithTooltip';
import ModificationRequestApprovableIconWithTooltip from '../../component/primitive/ModificationRequestApprovableIconWithTooltip';
import ModificationRequestInReviewIconWithTooltip from '../../component/primitive/ModificationRequestInReviewIconWithTooltip';
import ModificationRequestGivenFeedbackIcon from '../primitive/ModificationRequestGivenFeedbackIcon';

interface Props {
  state: 'given_feedback' | 'draft_exist' | 'accepting_deliverable' | 'in_review' | null;
}

const ModificationRequestStateIcon = ({ state }: ClassAttributes<HTMLElement> & Props) => (
  <>
    {state === 'given_feedback' ? <ModificationRequestGivenFeedbackIcon /> : null}
    {state === 'draft_exist' ? <DraftModificationRequestIconWithTooltip /> : null}
    {state === 'accepting_deliverable' ? <ModificationRequestApprovableIconWithTooltip /> : null}
    {state === 'in_review' ? <ModificationRequestInReviewIconWithTooltip /> : null}
  </>
);

export default ModificationRequestStateIcon;
